export enum PhlebotStatus {    
    Sent = 0,
    Pending = 2,
    ApplicantUnavailableUntil = 13,
    OrderReceivedByExamCentral = 1003800779,
    LetterSentToApplicant = 57,
    ApplicantCancelledRequest = 7,
    ApplicantWantsToTalkToAgentAgency = 14,
    TemporarilySuspendedByAgent = 1003800720,
    ApplicantRefusedService = 11,
    UnableToDrawBlood = 103,
    UnableToObtainUrine = 104,
    NeedApplicantInformation = 1003800631,
    CompletedByAnotherCompany = 1003800510,
    RequestCancelled = 1003800522,
    AgentCancelledRequest = 1003800500,
    DuplicateRequest = 1003800531,
    ConfirmRequestReceived = 32,
    RescheduledDueToExaminerInterviewer = 91,
    CompletedAsScheduled = 28,
    ContactedProducerForAssistance = 1003800562,
    RescheduledDueToApplicant = 90,
    TemporarilySuspendedByApplicant = 99,
    NoShowByApplicant = 62,
    AppointmentConfirmed = 19,
    ApplicationPackagePickedUp = 16,
    ApplicationPackageNotPickedUp = 15,
    NoAnswerNoMachine = 60,
    AssignedToExaminerInterviewer = 23,
    ProcessingDelay = 1003800660,
    ServicesChangedOrCorrected = 1003800687,
    ApplicantStatedDidNotApplyForInsurance = 12,
    AppointmentCanceledByApplicant = 3,
    NoShowByApplicantForAppointment = 1,
    ParamedAppointmentScheduled = 69,
    ReinstateCase = 1003800671,
    Other = 2147483647,
    LeftMessageForApplicant = 1003800526,
    RescheduledApptDate = 89,
    OrderConfirmed = 1003800712
}